import { useDraggable } from "@dnd-kit/core";
import VentaOnlineCard from "../../../../Components/VentaOnlineCard";

const DraggableCard = (props) => {
  const {
    venta,
    envio,
    isDragDisabled,
    onVerGuia,
    onVerificarPago,
    onVerificarPagoMattilda,
    onPagarManualmente,
    onConfirmarTransferencia,
    onReenviarCorreo,
    onVerEstadoGeneral,
    onSeguirEmpaquetando,
    badgeGrupo,
    mostrarDetalles,
    permisoConfirmarPago,
  } = props;

  const uniqueId = `${venta._id}-${envio.origen}`;

  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useDraggable({
      id: uniqueId,
      disabled: isDragDisabled,
      data: { venta, envio },
    });

  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
        zIndex: 999,
        opacity: isDragging ? 0.5 : 1,
      }
    : undefined;

  return (
    <div
      ref={setNodeRef}
      style={{
        ...style,
        opacity: isDragging ? 0 : 1, 
        cursor: isDragDisabled ? "not-allowed" : "grab",
      }}
      {...listeners}
      {...attributes}
    >
      <VentaOnlineCard
        venta={venta}
        envio={envio}
        onVerGuia={onVerGuia}
        onVerificarPago={onVerificarPago}
        onVerificarPagoMattilda={onVerificarPagoMattilda}
        onPagarManualmente={onPagarManualmente}
        onConfirmarTransferencia={onConfirmarTransferencia}
        onReenviarCorreo={onReenviarCorreo}
        onVerEstadoGeneral={onVerEstadoGeneral}
        onSeguirEmpaquetando={onSeguirEmpaquetando}
        badgeGrupo={badgeGrupo}
        mostrarDetalles={mostrarDetalles}
        permisoConfirmarPago={permisoConfirmarPago}
      />
    </div>
  );
};

export default DraggableCard;
